import {default as VtxModal} from './VtxModal';
import {default as DraggableModal} from './draggableModal';

VtxModal.DraggableModal = DraggableModal;

export default VtxModal;
export {VtxModal,DraggableModal};